<template>

  <b-container>
    <b-row class="d-flex flex-row justify-content-start p-3"><h5>مدیریت کامنت ها</h5></b-row>
    <b-row class="d-flex flex-row justify-content-start px-0 py-3 m-0">
      <b-col v-for="filter in filters" :key="filter.index"
             class="d-flex flex-column justify-content-center align-items-center m-0 py-2 px-1">
        <b-button pill class="bg-danger text-white m-0" size="sm" @click="filterComments(filter.value)"
                  v-if="filter.value===currentFilter">{{ filter.label }}
        </b-button>
        <b-button pill class="bg-info m-0" size="sm" @click="filterComments(filter.value)" v-else>{{
            filter.label
          }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="d-flex flex-row justify-content-center p-0 pt-3 m-0 w-100">
      <b-tabs content-class="mt-3 p-0 w-100" v-model="tabIndex"
              active-nav-item-class="font-weight-bold text-uppercase text-light bg-dark" fill>

        <b-tab title="کامنت های منتظر بازبینی" active class="w-100" @click="loadComments(commentStatus.WAITING.value)">
          <b-row class="d-flex flex-row justify-content-center align-items-center h-100">
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-2 h-100"
                   v-for="comment in comments" :key="comment.id" v-if="currentState===commentStatus.WAITING.value">
              <CommentCard :comment="comment"/>
            </b-col>
          </b-row>
          <b-row class="w-100">
            <b-col class="d-flex flex-column align-items-center">
              <Pagination :meta="meta" :on-change-page="changePage"/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="کامنت های پذیرفته شده" class="w-100" @click="loadComments(commentStatus.APPROVED.value)">
          <b-row>
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-2 h-100"
                   v-for="comment in comments" :key="comment.id" v-if="currentState===commentStatus.APPROVED.value">
              <CommentCard :comment="comment"/>
            </b-col>
          </b-row>
          <b-row class="w-100">
            <b-col class="d-flex flex-column align-items-center">
              <Pagination :meta="meta" :on-change-page="changePage"/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="کامنت های رد شده" class="w-100" @click="loadComments(commentStatus.REJECTED.value)">
          <b-row>
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-2 h-100"
                   v-for="comment in comments" :key="comment.id" v-if="currentState===commentStatus.REJECTED.value">
              <CommentCard :comment="comment"/>
            </b-col>
          </b-row>
          <b-row class="w-100">
            <b-col class="d-flex flex-column align-items-center">
              <Pagination :meta="meta" :on-change-page="changePage"/>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="سطل زباله" class="w-100" @click="loadTrash">
          <b-row>
            <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-2"
                   v-for="comment in trash" :key="comment.id">
              <TrashedComment :comment="comment"/>
            </b-col>
          </b-row>
          <b-row class="w-100">
            <b-col class="d-flex flex-column align-items-center">
              <Pagination :meta="trashMeta" :on-change-page="changeTrashPage"/>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-row>
  </b-container>

</template>

<script>
import {mapGetters} from "vuex";
import CommentFilter from "@moeinmdn/mixitweb-front-modules/src/plugin/class/CommentFilter";
import CommentStatus from "@moeinmdn/mixitweb-front-modules/src/plugin/class/CommentStatus";
import CommentCard from "../../components/dashboard/comment/CommentCard";
import TrashedComment from "../../components/dashboard/comment/TrashedComment";
import Pagination from "../../components/dashboard/Pagination";

export default {
  name: "Comments",
  components: {CommentCard, TrashedComment, Pagination},
  data() {
    return {
      filters: CommentFilter,
      currentFilter: 'product',
      tabIndex: 0,
      currentState: CommentStatus.WAITING.value,
      commentStatus: CommentStatus
    }
  },
  computed: {
    ...mapGetters({
      comments: "Comment/getComments",
      meta: "Comment/getMeta",
      trash: "Comment/getTrash",
      trashMeta: "Comment/getTrashMeta"
    }),
  },
  methods: {
    filterComments(filter) {
      let form = {comment_type: filter, status: this.currentState, page: 1}
      this.$store.dispatch("Comment/getComments", form).then(res => {
        this.tabIndex = this.currentState
        this.currentFilter = filter
      })
    },
    changePage(page) {
      let form = {page: page, status: this.currentState, comment_type: this.currentFilter}
      this.$store.dispatch("Comment/getComments", form);
    },
    changeTrashPage(page) {
      this.$store.dispatch("Comment/getTrash", page)
    },
    loadComments(status) {
      this.currentState = status
      let form = {comment_type: this.currentFilter, status: status, page: 1}
      this.$store.dispatch("Comment/getComments", form)
    },
    loadTrash() {
      this.$store.dispatch("Comment/getTrash")
    }
  },
  mounted() {
    let form = {comment_type: CommentFilter.PRODUCT.value, status: CommentStatus.WAITING.value, page: 1}
    this.$store.dispatch("Comment/getComments", form)
    this.$store.dispatch("Comment/getTrash")
  }
}
</script>

<style scoped>
.tabs {
  width: 100%;
  font-size: 12px;
}
</style>